import { render, staticRenderFns } from "./Reassign.vue?vue&type=template&id=a949b5b8&scoped=true"
import script from "./Reassign.vue?vue&type=script&lang=js"
export * from "./Reassign.vue?vue&type=script&lang=js"
import style0 from "./Reassign.vue?vue&type=style&index=0&id=a949b5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a949b5b8",
  null
  
)

export default component.exports